import { Col, DatePicker, Form, Icon, Input, Row } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import useFetch from 'elements/Hooks/useFetch'
import useFetchSelect from 'elements/Hooks/useFetchSelect'
import { RFQApi } from '../../../api/Sales/RFQ'
import DeliveryDetails from '../../../elements/DeliveryDetails'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import MultiCurrency from '../../../elements/MultiCurrency'
import RegisteredPartnerDetails from '../../../elements/RegisteredPartnerDetails'
import Taxes from '../../../elements/Taxes'
import { get, isEmpty, set } from 'lodash'
import { defaultFormItemLayout, rules } from '../../../modules/FormItems'
import { arrVal, dateVal, numVal } from '../../../modules/Utils'
import moment from 'moment'
import React, { useEffect } from 'react'

import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import withSort from '../../../elements/HOC/withSort'
import withSpinning from '../../../elements/HOC/withSpinning'
import InfoTooltip from '../../../elements/InfoTooltip'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withData from '../../../elements/Select/withData'
import withUrlFetch from '../../../elements/Select/withUrlFetch'

function VendorQuotesForm(props) {
  const { vendorQuote, rfqID, vendorID } = props
  const { getFieldDecorator, setFieldsValue, resetFields, getFieldValue } = props.form

  const vendor = getFieldValue('vendor._id') || ''

  const { SelectData: RFQSelect } = useFetchSelect({
    queryKey: `rfq/owner/${vendor}`,
    url: `rfq?select=_id,code,title,requirement,type,delivery,status&owner=${vendor}&active=true`,
    dependencyArray: [vendor],
    dontFetch: isEmpty(vendor),
    mapFunction: (r) => ({ ...r, display: `[${r.code}] - ${r.title}` }),
  })

  const [goods, setGoods] = React.useState(1)

  useEffect(() => {
    if (vendorQuote._rev) setGoods(arrVal(vendorQuote, 'delivery.dangerousGoods').length)
  }, [vendorQuote._rev])

  const { data: rfq } = useFetch({
    url: `rfq/${(getFieldValue('rfq._id') || '').replace('rfq/', '')}`,
    dependencyArray: [getFieldValue('rfq._id')],
    dontFetch: isEmpty(getFieldValue('rfq._id')) || vendorQuote._id,
  })

  let rfqFormID = getFieldValue('rfq._id') || rfqID
  const rfqKey = rfqFormID && rfqFormID.replace('rfq/', '')

  const { SelectData: FileSelectCmp } = useFetchSelect({
    url: `files/?folder=${vendorQuote._id}`,
    dependencyArray: [vendorQuote._id],
    dontFetch: isEmpty(vendorQuote._id),
  })

  React.useEffect(() => {
    if (!isEmpty(rfq) && !vendorQuote._id) {
      console.log(rfq)
      setFieldsValue({
        title: rfq.title,
        delivery: rfq.delivery,
        'company._id': rfq.company._id,
        type: rfq.requirement,
      })
      set(vendorQuote, 'delivery.address.label', get(rfq, 'delivery.address.label'))
    }
  }, [rfq._rev])

  const isLogistics = getFieldValue('type') === 'Logistics'

  return (
    <Form>
      <FormSectionTitle title={'VENDOR QUOTE DETAILS'} />
      <RegisteredPartnerDetails
        doc={vendorQuote}
        {...{
          getFieldDecorator,
          getFieldValue,
          setFieldsValue,
          type: 'vendorQuote',
          vendorID,
        }}
      />

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="RFQ">
            {getFieldDecorator('rfq._id', {
              initialValue: get(vendorQuote, 'rfq._id') || rfqID,
              rules: rules.select,
            })(
              <RFQSelect
                style={{ width: rfqKey !== undefined ? '80%' : '100%' }}
                keyAtr={'_id'}
                valueAtr={'display'}
                placeholder="Select a RFQ"
              />
            )}
            {rfqKey !== undefined && (
              <Link target={'_blank'} to={`/purchasing/rfq/${rfqKey}/update`}>
                <Icon style={{ marginLeft: 5 }} type="fullscreen" />
              </Link>
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <FormItem
            {...defaultFormItemLayout}
            label={<InfoTooltip value={'Type'} title={'Note: Logistics should be selected for Freight Quotes'} />}>
            {getFieldDecorator('type', {
              initialValue: get(vendorQuote, 'type') || get(rfq, 'requirement'),
              rules: rules.select,
            })(<RFQRequirementSelect style={{ width: '100%' }} />)}
          </FormItem>
        </Col>
        {isLogistics && (
          <>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Booking Type">
                {getFieldDecorator('freight.bookingType', {
                  initialValue: get(vendorQuote, 'bookingType'),
                  rules: rules.select,
                })(<BookingType />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Carriage Type">
                {getFieldDecorator('freight.carriageType', {
                  initialValue: get(vendorQuote, 'carriageType'),
                  rules: rules.select,
                })(<CarriageType />)}
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Title">
            {getFieldDecorator('title', {
              initialValue: get(vendorQuote, 'title'),
              rules: rules.select,
            })(<Input />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            {...defaultFormItemLayout}
            label={
              <InfoTooltip value={'Vendor Quotation'} title={'If empty; please upload files in documents tab.'} />
            }>
            {getFieldDecorator('quoteDoc', {
              initialValue: get(vendorQuote, 'quoteDoc'),
            })(<FileSelectCmp keyAtr="_id" valueAtr="name" placeholder={'Vendor Quote'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Quote Date">
            {getFieldDecorator('date.quote', {
              initialValue: dateVal(vendorQuote, 'date.quote') || moment(),
              rules: rules.select,
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Validity End">
            {getFieldDecorator('date.validity', {
              initialValue: dateVal(vendorQuote, 'date.validity'),
              rules: rules.select,
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Quote No">
            {getFieldDecorator('quoteNo', {
              initialValue: get(vendorQuote, 'quoteNo'),
              rules: rules.select,
            })(<Input placeholde={'Enquirer Reference'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <MultiCurrency
          doc={vendorQuote}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            type: 'vendorQuote',
          }}
        />
      </Row>
      <Row>
        <Taxes
          doc={vendorQuote}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            type: 'vendorQuote',
            price: numVal(vendorQuote, 'subTotal.net'),
            // hideRate: true,
          }}
        />
      </Row>
      <Row>
        <DeliveryDetails
          doc={vendorQuote}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            type: 'vendorQuote',
          }}
        />
      </Row>
    </Form>
  )
}

const RFQRequirementSelect = compose(
  withData({
    data: [
      { value: 'Logistics', key: 'Logistics' },
      { value: 'Service', key: 'Service' },
      { value: 'Supply', key: 'Supply' },
    ],
  }),
  withSort
)(CustomSelect)

const BookingType = compose(
  withData({
    data: [
      { value: 'Door-To-Door', key: 'Door-To-Door' },
      { value: 'Customs Clearance', key: 'Customs Clearance' },
      { value: 'Clearance & Delivery', key: 'Clearance & Delivery' },
      { value: 'Courier', key: 'Courier' },
      { value: 'Hand-Carry', key: 'Hand-Carry' },
      { value: 'Local Carriage', key: 'Local Carriage' },
      { value: 'International Carriage', key: 'International Carriage' },
    ],
  }),
  withSort
)(CustomSelect)

const CarriageType = compose(
  withData({
    data: [
      { value: 'Air Freight', key: 'AirFreight' },
      { value: 'Land Freight', key: 'LandFreight' },
      { value: 'Sea Freight', key: 'SeaFreight' },
      { value: 'Intermodal', key: 'Intermodal' },
    ],
  }),
  withSort
)(CustomSelect)

VendorQuotesForm.propTypes = {}
VendorQuotesForm.defaultProps = {}

export default Form.create()(VendorQuotesForm)
